import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ToastService {

  private openToast = new Subject<any>();
  openToastObs = this.openToast.asObservable();
  toastOpen(open? : boolean, message ?:string, type?:string){
    this.openToast.next({open, message, type})
  }
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/service/toast.service.ts